<template>
  <div>
    <h1>Reviews</h1>
    <v-data-table
      :pagination.sync="pagination"
      :total-items="reviewCount"
      :loading="loading"
      :headers="headers"
      :items="reviews"
      :footer-props="{ showFirstLastPage, showCurrentPage }"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <tr>
          <td>{{ props.item.id }}</td>
          <td><FileZ :file="props.item.file" /></td>
          <td>
            {{ props.item.reviewsite ? props.item.reviewsite.name : "unfound" }}
          </td>
          <td>
            <star-rating
              v-model="props.item.rating"
              :star-size="20"
              read-only
            />
          </td>
          <td>{{ props.item.timestamp | formatDate }}</td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import StarRating from "vue-star-rating";
import FileZ from "@/components/link/FileZ";
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "Reviews",
  metaInfo() {
    return {
      title: "Reviews",
      titleTemplate: "%s - Directory - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  components: { FileZ, StarRating },
  data() {
    return {
      reviewCount: 0,
      reviews: [],
      reviewSites: [],
      headers: [
        {
          text: "Id",
          value: "id"
        },
        {
          text: "File",
          value: "file.id"
        },
        {
          text: "Review site",
          value: "reviewsite.name"
        },
        {
          text: "Rating",
          value: "rating"
        },
        {
          text: "Timestamp",
          value: "timestamp"
        }
      ],
      loading: false,
      pagination: {
        page: 1,
        rowsPerPage: 10
      },
      showFirstLastPage: true,
      showCurrentPage: true
    };
  },
  methods: {
    async fetchReviewCount() {
      const response = await nbmlaw.get(`/cors/admin/directory/reviews/count`);
      // console.log(response.data)
      this.reviewCount = response.data;
    },
    async fetchReviews() {
      const { sortBy, descending, page, rowsPerPage } = this.pagination;
      //   console.log("sort by: " + sortBy + ", sort descending: " + descending);
      let firstRow = (page - 1) * rowsPerPage;
      //   console.log("firstRow: " + firstRow + ", rowsPerPage: " + rowsPerPage);
      const response = await nbmlaw.get(`/cors/admin/directory/reviews`, {
        params: {
          sortBy,
          descending,
          first: firstRow,
          pageSize: rowsPerPage
        }
      });
      // console.log(response.data);
      this.reviews = response.data;
      this.loading = false;
    },
    async fetchReviewSites() {
      const response = await nbmlaw.get(`/cors/admin/directory/reviewSites`);
      // console.log(response.data);
      this.reviewSites = response.data;
    },
    update() {
      this.loading = true;
      this.fetchReviewCount();
      this.fetchReviews();
    }
  },
  watch: {
    pagination: {
      handler() {
        this.update();
      },
      deep: true
    }
  },
  created() {
    this.update();
    this.fetchReviewSites();
  }
};
</script>